import { AuthenticationService } from "../services/authentication.service";
import { Injectable } from "@angular/core";
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from "@angular/router";
import { UserRoleNames } from "../models/users";

@Injectable({
  providedIn: "root",
})
export class RouteGuard {
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (this.authenticationService.loggedIn()) {
      let url: string = state.url;
      return this.checkUserLogin(next, url);
    } else {
      this.router.navigate(["Login"]);
      return false;
    }
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (this.authenticationService.loggedIn()) {
      let url: string = state.url;
      return this.checkUserLogin(next, url);
    } else {
      this.router.navigate(["Login"]);
      return false;
    }
  }

  isLicenseExpired(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    if (
      localStorage.getItem("LicenseExpired") &&
      localStorage.getItem("LicenseExpired") == "true"
    ) {
      this.router.navigate(["Configurator/SyncHPC Settings"]);
      return false;
    }
    return true;
  }

  checkUserLogin(route: ActivatedRouteSnapshot, url: any): boolean {
    if (url.includes("desktopapp")) {
      this.router.navigate(["/client/desktopapp/login"]);
      return false;
    }
    if (this.authenticationService.loggedIn()) {
      const userRole = this.authenticationService.getRole();
      // if (route.data.role && route.data.role.indexOf(userRole) === -1) {
      //   this.router.navigate(['/']);
      //   this.checkLicenseExpiry();
      //   return false;
      // }
      if (url.includes("Configurator")) {
        if (
          userRole == UserRoleNames.JobOperator ||
          userRole == UserRoleNames.DeploymentAdmin
        ) {
          this.router.navigate(["/"]);
          return false;
        }
      }
      this.checkLicenseExpiry();
      return true;
    }
    this.router.navigate(["/"]);
    this.checkLicenseExpiry();
    return false;
  }

  checkLicenseExpiry() {
    if (
      localStorage.getItem("LicenseExpired") &&
      localStorage.getItem("LicenseExpired") == "true"
    ) {
      setTimeout(() => {
        this.router.navigate(["Configurator/SyncHPC Settings"]);
      }, 100);
    }
  }
}
